var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.formattedCategories,"append-icon":"mdi-magnify","loading":_vm.isLoading,"disabled":_vm.isLoading,"small-chips":"","clearable":""},model:{value:(_vm.chosenCategory),callback:function ($$v) {_vm.chosenCategory=$$v},expression:"chosenCategory"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }